export default __webpack_public_path__ + "static/media/chemical.558b5bd9.jpg";